import { Stage, useBingoGameStore } from "@/plugins/bingo/state/bingoGameStore";

const STAGES = [
  { key: Stage.ONE_LINE, label: "1 Line" },
  { key: Stage.TWO_LINES, label: "2 Lines" },
  { key: Stage.FULL_HOUSE, label: "Full House" },
];

/**
 * StageSelector: 3-step segmented progression.
 * Host advances manually once a winner is verified.
 */
export default function StageSelector() {
  const stage = useBingoGameStore((s) => s.stage);
  const setStage = useBingoGameStore((s) => s.setStage);

  return (
    <div>
      <div className="text-[10px] tracking-[0.3em] uppercase text-[color:var(--ic-text-muted)] mb-1.5">
        Stage
      </div>
      <div
        data-testid="host-stage-selector"
        className="grid grid-cols-3 gap-1 p-1 rounded-md border border-[color:var(--ic-border-subtle)] bg-[color:var(--ic-bg-elevated)]"
      >
        {STAGES.map((s) => {
          const active = stage === s.key;
          return (
            <button
              key={s.key}
              data-testid={`host-stage-${s.key}`}
              type="button"
              onClick={() => setStage(s.key)}
              className="h-8 rounded text-xs font-medium transition-colors"
              style={
                active
                  ? {
                      background: "var(--ic-primary)",
                      color: "#000",
                      boxShadow: "0 0 12px var(--ic-primary-glow)",
                    }
                  : {
                      background: "transparent",
                      color: "var(--ic-text-secondary)",
                    }
              }
            >
              {s.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
